import React from 'react'
import StatusLight from '../../../components/Status/StatusLight'

const AppointmentNotGrantedStatusRenderer = () => {
  return <StatusLight status='error' size='16px' />
}

export default AppointmentNotGrantedStatusRenderer
